import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'
import Loadable from 'src/utils/loadable'
import AclRoute from 'src/components/Router/AclRoute'
// import KeepAliveRoute from 'src/components/Router/KeepAliveRoute'

class Routes extends Component {
  componentDidMount() {
    this.props.rendered()
  }

  render() {
    return (
      <React.Fragment>
        {/* TODO: PAT-1739 Cleanup */}
        {/* Loading on all pages */}
        {/*<KeepAliveRoute path="/chat" component={Loadable(() => import('src/modules/Chat'))} />*/}
        <Switch>
          <Route exact path="/" component={Loadable(() => import('src/modules/Home'))}/>
          <Route exact path="/chat" component={Loadable(() => import('src/modules/Chat'))}/>
          {/*<Route path="/chat" component={() => ''}/>*/}
          <AclRoute
            path="/quote"
            feature="requestQuote"
            component={Loadable(() => import('src/modules/Quotes'))}
          />
          <AclRoute
            isPrivate
            path="/documents"
            feature="documents"
            component={Loadable(() => import('src/modules/Documents'))}
          />
          <AclRoute
            isPrivate
            path="/claims"
            feature="reportClaim"
            component={Loadable(() => import('src/modules/Claims'))}
          />
          <AclRoute
            path="/payments"
            feature="payments"
            component={Loadable(() => import('src/modules/Payments'))}
          />
          <AclRoute
            isPrivate
            path="/inventory"
            feature="inventory"
            component={Loadable(() => import('src/modules/Inventory'))}
          />
          <AclRoute
            isPrivate
            path="/user"
            feature="user"
            component={Loadable(() => import('src/modules/Users'))}
          />
          <AclRoute
            isPrivate
            path="/users"
            feature="users"
            component={Loadable(() => import('src/modules/Users'))}
          />
          <AclRoute
            isPrivate
            path="/contact"
            feature="contact"
            component={Loadable(() => import('src/modules/Contact'))}
          />
          <Route
            path="/services"
            component={Loadable(() => import('src/modules/Services'))}
          />
          <Route
            path="/cp"
            component={Loadable(() => import('src/modules/CustomPage'))}
          />
          <AclRoute
            path="/auth"
            feature="auth"
            component={Loadable(() => import('src/modules/Auth'))}
          />
          <Route path="/helpers/icons" component={Loadable(() => import('src/components/SvgIcon/List'))}/>
          <Route path="*" component={Loadable(() => import('src/modules/NotFound'))}/>
        </Switch>
      </React.Fragment>
    )
  }
}

export default Routes
